<template>
  <div class="">
    <v-select
      v-model="userList"
      :options="userlListOptions"
      :clearable="false"
      multiple
      @input="onChange"
      @search="onSearch"
      :disabled="isSelectDisabled"
      :selectable="(option) => userList.length < maxLength"
      append-to-body
    />
    <div class="d-flex flex-column">
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";
import {debounce} from "lodash";
import axios from "@axios";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    fieldOptions: Object,
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    }
  },
  setup(props, { emit }) {
    const maxLength = ref(1000);
    const search = ref("");
    const limit = ref(8);
    const userList = ref([]);
    const options = ref(null);
    const isSelectDisabled = ref(false);
    const error = ref(false);
    const userlListOptions = computed(() =>
      (options.value || []).map(u => ({
        value: `${u.username ?? ''}-${u.full_name}`,
        label: u.full_name,
      }))
    );

    onMounted(() => {
      isSelectDisabled.value = props.isFormDisabled ?? false;
      maxLength.value = props?.field?.options?.fieldTypeCfg?.data[0]?.maxLength ?? maxLength.value
      fetchData()
    });

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get("/v1/users", {
          params: {
            q: search.value,
            max: limit.value,
            sortBy: 'id',
            'with[]': 'profile',
          },
        });
        options.value = data.data;
      } catch (error) {
        console.error(`MailList: request error`, error?.response || error);
      }
    }

    async function onChange(value) {
      emit("updateData", props.field, userList.value);
    }


    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        await fetchData();
        loading(false);
      } else {
        search.value = '';
        await fetchData();
      }
    }, 500);

    return {
      userList,
      userlListOptions,
      isSelectDisabled,
      error,
      maxLength,
      onSearch,
      onChange
    }
  }
}
</script>
<style scoped>
.text-error {
  color: #ec0303;
}
</style>